import React, { useState, useEffect } from 'react';
import WorkflowEditor from './workflowEditor';
import { apiFetch } from './api';

const Workflows = ({ user }) => {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [neu, setNeu] = useState(false);
  const [name, setName] = useState('');
  const [beschreibung, setBeschreibung] = useState('');
  const [aktiv, setAktiv] = useState(null);

  const lade = async () => {
    const res = await apiFetch('/workflows');
    const data = await res.json();
    setWorkflows(data);
    setLoading(false);
  };

  useEffect(() => { lade(); }, []);

  const erstellen = async () => {
    if (!name) return;
    await apiFetch('/workflows', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, beschreibung, erstellt_von: user.id })
    });
    setName(''); setBeschreibung(''); setNeu(false);
    lade();
  };

  const loeschen = async (id) => {
    await apiFetch(`/workflows/${id}`, { method: 'DELETE' });
    lade();
  };

  if (aktiv) {
    return <WorkflowEditor workflowId={aktiv} onZurueck={() => { setAktiv(null); lade(); }} />;
  }

  return (
    <div style={{ padding: '40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '32px' }}>
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>
            Workflows
          </h2>
          <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>
            Wiederverwendbare Projektvorlagen mit automatischen Task-Deadlines
          </p>
        </div>
        <button onClick={() => setNeu(true)} style={{
          padding: '8px 16px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
          borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
        }}>+ Neuer Workflow</button>
      </div>

      {neu && (
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px', padding: '24px', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 16px 0' }}>Neuer Workflow</h3>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)}
              placeholder="z.B. Podcast-Folge Standard" autoFocus
              onKeyDown={(e) => { if (e.key === 'Enter') erstellen(); if (e.key === 'Escape') { setNeu(false); setName(''); setBeschreibung(''); } }}
              style={{ width: '100%', padding: '10px 14px', fontSize: '14px', border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Beschreibung</label>
            <input type="text" value={beschreibung} onChange={(e) => setBeschreibung(e.target.value)}
              placeholder="Optional"
              style={{ width: '100%', padding: '10px 14px', fontSize: '14px', border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={erstellen} style={{
              padding: '8px 20px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
              borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
            }}>Erstellen</button>
            <button onClick={() => { setNeu(false); setName(''); setBeschreibung(''); }} style={{
              padding: '8px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
              border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
            }}>Abbrechen</button>
          </div>
        </div>
      )}

      {loading ? (
        <p style={{ color: '#9b9b9b', fontSize: '14px' }}>Lädt...</p>
      ) : workflows.length === 0 ? (
        <div style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '60px 40px', border: '1px solid #efefef', textAlign: 'center' }}>
          <p style={{ color: '#9b9b9b', fontSize: '14px', margin: '0 0 8px 0' }}>Noch keine Workflows.</p>
          <p style={{ color: '#c4c4c4', fontSize: '13px', margin: 0 }}>Erstelle deinen ersten Workflow, um Projekte mit einem Klick anzulegen.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {workflows.map(w => (
            <div key={w.id} style={{
              backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px 24px',
              border: '1px solid #efefef', display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div onClick={() => setAktiv(w.id)} style={{ cursor: 'pointer', flex: 1 }}>
                <p style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 4px 0' }}>{w.name}</p>
                {w.beschreibung && <p style={{ fontSize: '13px', color: '#9b9b9b', margin: 0 }}>{w.beschreibung}</p>}
                {w.erstellt_von_name && <p style={{ fontSize: '11px', color: '#c4c4c4', margin: '4px 0 0 0' }}>Erstellt von {w.erstellt_von_name}</p>}
              </div>
              <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
                <button onClick={() => setAktiv(w.id)} style={{
                  padding: '6px 14px', backgroundColor: 'transparent', border: '1px solid #e8e8e8',
                  borderRadius: '6px', fontSize: '12px', color: '#6b6b6b', cursor: 'pointer'
                }}>Bearbeiten</button>
                <button onClick={() => loeschen(w.id)} style={{
                  padding: '6px 14px', backgroundColor: 'transparent', border: '1px solid #ffdddd',
                  borderRadius: '6px', fontSize: '12px', color: '#cc0000', cursor: 'pointer'
                }}>Löschen</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Workflows;